export default {
  title: 'Submit changes',
  text: 'You are about to import contributions',
  buttonCancel: 'Cancel import',
  buttonSubmit: 'Submit',
};
